import React from 'react'
import './footer.css'
import logo from '../assets/logo.jpeg'
import {FaFacebookF,FaTwitter,FaInstagram} from 'react-icons/fa'

const footer = () => {
  return (
    <footer>
      <img className='logoImage' src={logo}></img>
      <div className='footer__logo'>Tactical Bazar</div>
      <ul className='permalinks'>
      <p>We Are The Largest And Most Reliable Firearms Dealer In Pakistan</p>
      </ul>

      <div className="footer__socials">
        <a href="https://www.facebook.com/profile.php?id=100088504625693&mibextid=LQQJ4d"><FaFacebookF></FaFacebookF></a>
        
        <a href="https://instagram.com/thetacticalbazaar?igshid=YmMyMTA2M2Y="><FaInstagram></FaInstagram></a>
      </div>
      
      <div className="footer__copyright">
        <small>&copy; Copyright © 2022 Tactical Bazar. All Rights Reserved.</small>
      </div>
    </footer>
  )
}

export default footer